// extracted by mini-css-extract-plugin
export default {"button":"BanxNotificationsButton-module__button--AnBMQ","buttonActive":"BanxNotificationsButton-module__buttonActive--spaEq"};